import { render } from "./ResponseError.vue?vue&type=template&id=2d249714"
import script from "./ResponseError.vue?vue&type=script&lang=js"
export * from "./ResponseError.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/ResponseError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d249714"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d249714', __exports__)) {
    api.reload('2d249714', __exports__)
  }
  
  module.hot.accept("./ResponseError.vue?vue&type=template&id=2d249714", () => {
    api.rerender('2d249714', render)
  })

}


export default __exports__